import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import report from '@/assets/images/cards/report.svg'
import { changeUserInfo } from '@/store/module/tabbar';
import { addChatList, popChatList, removeChatList, changeLoading, changeActionList, changeChatList } from '@/store/module/progress';
import { removeShareLogList } from "@/store/module/createAvatar"
import markdownit from 'markdown-it'
import "./Talk.less"
import { getShopPayCountHandle } from "@/api/starpay.js"
import selectActive from "@/assets/images/selectActive.png"

import copy_Completed from "@/assets/images/copy_Completed.png"
import download from "@/assets/images/download.png"
import coin from '@/assets/images/coin.png'
import coins from '@/assets/images/coins.png'
import copy from '@/assets/images/copy.png'
import audioImg from "@/assets/images/talk/audio.png"
import starspay from "@/assets/component/starspay/icon.png"
import share from "@/assets/images/share.png"
import keys from "@/assets/images/talk/keys.png"
import faceImg from "@/assets/images/talk/face.png"
import sendImg from "@/assets/images/talk/send.png"
import lineImg from "@/assets/images/talk/line.png"
import nftImg from "@/assets/images/newNfted.png"
import actionbtn from "@/assets/images/talk/actionbtn.png"
import edit from "../../assets/images/talk/edit.png"
import border from "../../assets/images/talk/border.png"
import Chars from "@/components/Chat.tsx"
import { judgeClient } from '../../utils/judgeClient';
import PublicDialog from '@/components/PublicDialog'
import PublicDialogClose from "@/components/PublicDialogClose"
import AudioRecorder from "@/components/AudioRecorder"
import Emoji from "@/components/emoji/Emoji.tsx"
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { v4 as uuidv4 } from 'uuid';
import { useLocation, useParams } from "react-router-dom";
import { apiAvatarIntimacy } from "@/api/avatar"
import { getUserInfo, removeChatLogs, postLike, getCharacterInfo, searchSaveLogs, getSaveLogsLink, getActionCount, getActionList, getRefiningTips, reportCreateAvatar, putCurrentAvatarLanguage, getCurrentAvatarLanguage, getHistoryList, paySaveLogs } from '@/api/url'
import { getShopPayConfig } from "@/api/shop.js"
import { useNavigate, useSearchParams } from 'react-router-dom';

import DrawCardsDialog from '../../components/DrawCardsDialog'
import { postWarningInformation, updateDownLoadCount } from "@/api/url.js"
import BScroll from 'better-scroll'
import GetCoinAnimationDialog from '../../components/GetCoinAnimationDialog';
import CoinProgressBar from '../../components/CoinProgressBar';

import { Loading, Popup, Toast } from 'react-vant';
import TalkMessage from '../../components/message/TalkMessageToast';
import Back from '../../components/common/BackComp';
import { coinMovementOffset, downloadFile, formatIdString, formatNumber, FormattingTwoNumber } from '../../utils';
import ButtonComp from '../../components/common/ButtonComp';
import PromptDialog from '../../components/PromptDialog';
import ShareLog from './ShareLog.tsx';
import { changeCharacterList, changeHomePage } from '../../store/module/tabbar.ts';
import CloseComp from '../../components/common/CloseComp.tsx';
import Pay from '../shop/pay.tsx';
import Mint from "../nft/Index"
import { getAvatarDetails } from "@/api/url.js"
import { pushChatListId, setCurrAvatarId, setCurrCharacterInfo } from '../../store/module/progress.ts';
import { changeLoginState } from '../../store/module/h5Login.ts';

import { useTranslation } from 'react-i18next';
import ShareContent from '../../components/ShareContent.tsx';
import { changeShopCount } from '../../store/module/lottery.ts';
import PayDialog from '../../components/common/PayDialog.tsx';
const sleep = (time: number) => new Promise((resolve) => setTimeout(resolve, time));
new BScroll('.emoji', {
    pullUpLoad: true,
    scrollbar: true,
    pullDownRefresh: true
    // and so on
})

type Message = {
    id: number,
    status: string,
    content: string,
    direction: string,
    type?: string
    audioUrl?: string
    durations?: number
    isHide?: number | null
    text: string
}


let isAllowSay = true; //是否允许说话
const md = markdownit()
let currID: any = ""
const Talk = () => {
    const { t } = useTranslation()
    //从缓存中拉取数字人列表数据
    // const characterList = JSON.parse(localStorage.getItem("characterList")!)
    const [networkError, setNetWorkError] = useState(false)
    const isError = useRef(false)
    const [coinCap, setCoinCap] = useState(false)
    const userInfo = useSelector((state: any) => state.tabbar.userInfo)
    const [isTalkMessage, setIsTalkMessage] = useState(false)
    const [messageText, setMessageText] = useState("")
    const talkRef = useRef<any>(null);
    const dialogRef = useRef<any>(null);
    const chatContainer = useRef<any>(null);
    const inputRef = useRef<any>(null);
    const [sendIsShow, setSendIsShow] = useState(false);
    const [claimPointsDialog, setClaimPointsDialog] = useState(false);
    const [dialog, setDialog] = useState(false)
    const [charList, setList] = useState<Message | []>([])
    const coinDomCoordinate = useSelector((state: any) => state.tabbar.coinDomCoordinate)
    const address_params = localStorage.getItem('address_params')
    const shareStatusList = useSelector((state: any) => state.progress.shareStatusList)
    const flag = useSelector((state: any) => state.tabbar.value);
    const languageArray = useSelector((state: any) => state.createAvatar.languageList)
    const [tasksData] = useState<any>(useSelector((state: any) => state.tasks.tasksData))
    const chatMessageList = useSelector((state: any) => state.progress.chatList)
    const actionListStore = useSelector((state: any) => state.progress.actionList)
    const currAvatarId = useSelector((state: any) => state.progress.currAvatarId)
    const currCharacterInfo = useSelector((state: any) => state.progress.currCharacterInfo) || window.localStorage.getItem("currCharacterInfo") && JSON.parse(window.localStorage.getItem("currCharacterInfo")!);
    const characterInfoId = useSelector((state: any) => state.progress.currCharacterInfo)
    const dispath = useDispatch()
    const [inputValue, setInput] = useState("");
    let [chatText, setChatText] = useState("");
    const [drawCard, setDrawCard] = useState(false);
    const _token = useSelector((state: any) => state.tabbar.token)
    const [cardUrl, setCardUrl] = useState("");
    const [property, setProperty] = useState<any>({});
    const [cardLevel, setCardLevel] = useState(0);
    const [description, setDescription] = useState('');
    const myText = useRef("")
    const [actionBtn, setActionBtn] = useState(false)
    const actionCount = useRef(3)
    // const [actionCount, setActionCount] = useState(0)
    const [isActionBtnLoading, setActionBtnLoading] = useState(false)
    const [activeIndex, setActiveIndex] = useState(0)
    const [coinAction, setCoinAction] = useState(false)
    const [actionList, setActionList] = useState<any>([])
    const [isGetActionList, setGetActionList] = useState(false)
    const [is_report, setReport] = useState(false)
    //--------------------  人物相关 ---------------------
    const [characterInfo, setCharacterInfo] = useState(currCharacterInfo)
    const [likeLoading, setLikeLoading] = useState(false)
    const [searchParams] = useSearchParams()
    const dispatch = useDispatch()
    //-------------------聊天动作按钮 ---------------------
    const [text, setText] = useState<any>('')
    const [promptText, setPromptText] = useState<any>('')
    const [pointsDialog, setPointsDialog] = useState(false)
    const [chatLogPay, setChatLogPay] = useState(false)
    const [isSaveChat, setIsSaveChat] = useState(false)
    const [saveChatLogPayDialog, setSaveChatLogPayDialog] = useState(false)
    const [saveLogs, setSaveLogs] = useState<any>({})
    const id = searchParams.get("id");
    const { pathname } = useLocation();
    const [key, setKey] = useState(0);
    const [card_report, setCard_report] = useState([])
    const initCharacterList = useSelector((state: any) => state.tabbar.characterList)
    const { name } = useParams();
    const characterRef = useRef('');

    const [prompt, setPrompt] = useState('')
    const [promptDialog, setPromptDialog] = useState(false)

    useEffect(() => {
        const getAvatarInfo = async () => {
            const { data, code } = await getAvatarDetails(name, name)
            if (code == '0') {
                if (data.avatar_type == 2) {
                    setPrompt(t("h5.text8"))
                    setPromptDialog(true)

                } else if (data.is_nsfw) {
                    setPrompt(t("h5.text9"))
                    setPromptDialog(true)
                } else {
                    dispatch(pushChatListId({ id: data.id, list: [], actionList: [] }))
                    dispatch(setCurrCharacterInfo(data))
                    setCharacterInfo(() => data)
                    setTimeout(() => {
                        characterRef.current = data.id
                        window.localStorage.setItem("currCharacterInfo", JSON.stringify(data));
                        dispatch(setCurrAvatarId(data.id))
                    }, 500)
                }
            }

        }

        if (name && !characterInfoId.id) {
            getAvatarInfo()
        }
    }, [])


    const getTips = useCallback(async () => {
        try {
            const { code, data } = await getRefiningTips()
            if (code == 0 && Array.isArray(data.card_report)) {
                setCard_report(data.card_report)
            }
        } catch (error) {
            console.log(error)
        }


    }, [])
    const addCount = useSelector((state: any) => state.tabbar.addCount)
    // useEffect(() => {
    //     const handleRefresh = async () => {
    //         if (id != searchParams.get("id")) {
    //             const { data, code } = await getCharacterInfo(searchParams.get("id"))
    //             if (code == '0' && data.ok) {
    //                 if (code == '0') {
    //                     dispatch(setCurrCharacterInfo(data))
    //                     window.localStorage.setItem("currCharacterInfo", JSON.stringify(data));
    //                     dispatch(setCurrAvatarId(searchParams.get("id")))
    //                     dispatch(changeHomePage({ showHomePage: false, id: '', }))
    //                     dispatch(pushChatListId({ id: searchParams.get("id"), list: [], actionList: [] }))

    //                     // getLogsList()
    //                     // getTips()
    //                 }
    //                 console.log("🚀 ~ handleRefresh ~ getLogsList:")
    //             }
    //         }
    //     }
    //     handleRefresh()
    // }, [addCount])

    const getLogsList = async () => {
        dispath(changeChatList({ id: characterRef.current || searchParams.get("id"), list: [] }))
        const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
        })
        try {
            const params = {
                id: searchParams.get("id") || currAvatarId || characterRef.current,
                page: 1,
                limit: 1000
            }
            const { code, data } = await getHistoryList(params)

            // if (!localStorage.getItem('token')) {
            //     sendMessage();
            // }

            if (code == "0") {
                toast.clear()

                const list = data && data.msgs.length > 0 && data.msgs.map((item: any) => {
                    return {
                        id: uuidv4(),
                        content: md.render(item.content),
                        text: item.content,
                        status: "success",
                        hidden: (item.msg_type == 1 && item.type == 1) ? true : false,
                        isHide: item.type,
                        direction: item.msg_type == 1 ? 'right' : item.msg_type == 2 ? 'left' : "",
                    }
                })

                if (list && list.length > 0) {
                    setTimeout(() => {
                        scrollToBottom();
                    }, 200)
                    dispath(changeChatList({ id: characterRef.current || searchParams.get("id"), list }))

                } else {

                    if (!sessionStorage.getItem("isSendMessage")) {
                        sendMessage();
                    }
                    sessionStorage.removeItem("isSendMessage")
                }
            }
        } catch (e) {
            toast.clear()
        }

    }
    useEffect(() => {
        for (let i = 0; i < chatMessageList.length; i++) {
            if (chatMessageList[i].id === characterInfo.id) {
                setList(chatMessageList[i].list)
            }

        }
    }, [chatMessageList, addCount, characterRef.current])

    //get current avatar language
    const getCurrentLanguage = async (id: string) => {
        if (!id) {
            setLanguageValue("English")
            return
        }
        try {
            const { code, data } = await getCurrentAvatarLanguage(id)
            if (code == 0) {
                setLanguageValue(data)

            } else {
                setLanguageValue("English")
            }
        } catch (e) {
            setLanguageValue("English")
        }
    }


    const [saveLogsTypeActive, setSaveLogsTypeActive] = useState(1)
    useEffect(() => {
        getLogsList()
        getTips()
    }, [characterRef.current])
    // const chatLogText = useMemo(() => {
    //     return chatLogPay || saveLogs?.persistent_type == 1 ? [
    //         "All chat logs with this Agent will be saved.",
    //         "Even if you exit StarAI, your entire chat history will remain intact for 6 months.",
    //         "This feature costs 9 Stars."
    //     ] : [
    //         "Chat Log will save the last 20 messages with this Agent.",
    //         "Your Chat Log won't be lost, even if you exit StarAI.",
    //         "It will be valid for 6 months and cost 200,000 $STAR."
    //     ]
    // }, [chatLogPay])

    const [payData, setPayData] = useState<any>({})
    const payHandle = async (item: any) => {
        setSaveChatLogPayDialog(false)
        let obj = {
            ...item,
            avatarId: currID,
            ts: new Date().getTime()
        }
        setPayData(obj)

    }
    const [payList, setPayList] = useState<any>([])

    const payImgType = [
        {
            name: 'STAR',
            names: 'STARS'
        },

        {
            name: 'TON',
            names: 'TON'
        },
        {
            name: 'USDT',
            names: 'USDT'
        },
        {
            name: 'BNB',
            names: 'BNB'
        },
    ]
    const chatLogText =
        [
            [
                t("talk.chatl"),
                t("talk.notlo"),
                t("talk.valid")
            ], [
                t("talk.allch"),
                t("talk.intac"),
                t("talk.featu"),


            ]]


    useLayoutEffect(() => {
        try {
            // window.localStorage.se1tItem("isFromTalkPage", "yes");
            currID = searchParams.get("id") || currAvatarId
            getCurrentLanguage(currID)
            getCharacter()
            // console.log(currAvatarId)
            setTimeout(() => {
                scrollToBottom();
            }, 200)
            for (let i = 0; i < chatMessageList.length; i++) {
                if (chatMessageList[i].id === characterInfo.id) {
                    // if (!chatMessageList[i].list.length) {
                    //     sendMessage();
                    // }
                    if (!chatMessageList[i].actionList.length) {
                        setGetActionList(true)
                    } else {
                        setGetActionList(false)
                    }
                }
            }
            // 
        } catch {

        }

    }, [addCount, characterRef.current])

    const [chatMessage, setChatMessage] = useState("")
    const [isShowTry, setShowTry] = useState(false)
    const currInputValue = useRef("")


    const sendMessage = async (text: string = "", type?: string) => {
        // characterInfo.id = ""
        if (!characterInfo.id && localStorage.getItem('token')) {
            return false;
        }
        isAllowSay = false;
        let ID = window.localStorage.getItem("userId") || "";

        const token = window.localStorage.getItem("token");
        const item: Message = {
            id: uuidv4(),
            status: "pending",
            content: '',
            text: "",
            direction: 'left'
        }
        dispath(addChatList({ id: currCharacterInfo.id, item }))
        setChatText("");
        myText.current = ""
        setInput("");
        dispath(changeLoading(false))
        // isShowTry = true;
        setShowTry(true)
        // console.log(characterInfo.id)
        setChatMessage("")
        fetchEventSource(`/api/v1/miniapp/character/${currID || characterRef.current}/chat`, {
            openWhenHidden: true,
            method: 'POST',
            headers: {
                'User-Source': 'H5',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                message: type != 'audio' ? text + "\n" : "",
                voice: type == 'audio' ? text + "\n" : ""
            }),

            async onmessage(res) {
                // isShowTry = false;
                setShowTry(false)
                // setChatText("");
                if (res.data.indexOf("code") !== -1) {
                    if (JSON.parse(res.data).code == -1) {
                        isError.current = true
                        dispath(popChatList(characterInfo.id))

                        setNetWorkError(true)

                        return false
                    }
                    isError.current = false
                    // setChatText("");
                    isAllowSay = true;
                    dispath(popChatList(currCharacterInfo.id));
                    // dispath(popChatList(characterInfo.id));
                    const { chat_message, voice, image, event, description, rewards, level, property, power } = JSON.parse(res.data).data;
                    let imgStr = "";
                    // const message = JSON.parse(res.data).data.chat_message;
                    if (image) {
                        imgStr = `<img src="${image}" style="width: 26px;height:26px;display: inline-block;vertical-align: middle;" class="dom_emoji" />`;
                    }
                    const item: Message = {
                        id: uuidv4(),
                        status: "success",
                        content: myText.current + imgStr,
                        text: chat_message + imgStr,
                        direction: "left",
                        type: "message",
                        audioUrl: voice,
                        isHide: !text ? 1 : null
                    }

                    dispath(addChatList({ id: currCharacterInfo.id, item }))
                    getCharacter();//获取当前角色数据，并更新数据
                    setTimeout(() => {
                        scrollToBottom();
                    }, 200)
                    //聊天卡牌
                    if (event) {
                        setDescription(description)
                        setCardLevel(level)
                        setCardUrl(event);
                        setDrawCard(true);
                        setProperty({
                            property,
                            power
                        })

                    }
                    if (rewards) {
                        const width = window.innerWidth;
                        const height = window.innerHeight;
                        getCoinAnimation(260, 560);
                        const UserInfo = await getUserInfo(address_params)
                        dispath(changeUserInfo(UserInfo.data))
                    }
                    if (rewards == -1) {
                        setCoinCap(true)
                    }
                } else {
                    res.data = res.data?.toString().replace(/\\n+/g, '\n\n')

                    if (res.data !== '==end==') {
                        setChatMessage(prev => prev + res.data)
                    }
                    myText.current += res.data;
                    if (res.data === '==end==') {
                        myText.current = md.render(myText.current.replace("==end==", "").toString());
                        setChatMessage(prev => md.render(prev))
                    }

                    setTimeout(() => {
                        scrollToBottom();
                    }, 200)
                }
            },

            onerror(err) {
                console.log(err)
                isAllowSay = true;
                setTimeout(() => {
                    setShowTry(false)
                }, 2000)
                throw err;
            },
            onclose() {
                console.log('WebSocket closed')
                isAllowSay = true;
            },
            async onopen(response) {
                if (!response.ok) {
                    setShowTry(false)
                    isError.current = true
                    setNetWorkError(true)
                    dispath(popChatList(currCharacterInfo.id));

                }
            },
        },
        ).catch(async (e) => {
            setShowTry(false)
            dispath(popChatList(currCharacterInfo.id));
            currID = searchParams.get("id") as string
            console.log(e)

            setShowTry(false)
            isError.current = true
            setNetWorkError(true)
        })
    }





    const sendHandle = async (val?: string) => {
        if (!isAllowSay) {
            // Toast.info({ message: '提示内容' });
            setIsTalkMessage(true)
            setMessageText(t("talk.finis"))

            setTimeout(() => {
                setIsTalkMessage(false)
            }, 900)
            return false;
        }
        if (inputValue.trim() !== '' || val?.trim() !== '') {
            currInputValue.current = inputValue
            setActionBtn(false)
            const item: Message = {
                id: uuidv4(),
                status: "success",
                content: val ? val + "\n" : inputValue + "\n",
                text: val ? val + "\n" : inputValue + "\n",
                direction: "right"
            }

            dispath(addChatList({ id: characterInfo.id, item }))
            dispath(changeActionList({ id: currID, list: [] }))
            setGetActionList(true)
            setSendIsShow(false)
            // dispath(changeTabbar(true))
            setEmoji(false);
            sendMessage(val ? val : inputValue)
            setTimeout(() => {
                scrollToBottom();
                if (judgeClient() == 'IOS') {
                    window.scrollTo(0, 0);
                }
            }, 200)
            try {
                const UserInfo = await getUserInfo(address_params)
                dispath(changeUserInfo(UserInfo.data))
            } catch (e) {
                console.log(e)
            }

        }
    }
    //键盘事件
    const keyDownHandle = async (e: any) => {
        e.stopPropagation();
        if (e.keyCode == 13) {
            // dispath(changeTabbar(false))
            blurHandle();
            sendHandle();

        }
    }



    useEffect(() => {
        if (inputValue.trim() !== '') {
            setSendIsShow(true)
        }

    }, [inputValue])

    //-------------------- 聊天页相关---------------------
    const [coinsShow, setCoinShow] = useState(true);//控制下边金币进度条
    const [headerShow, setHeaderShow] = useState(true);//控制顶部角色信息
    const mainRef = useRef<any>(null);
    useEffect(() => {
        // talkRef.current?.addEventListener('touchmove', (e) => {
        //     e.preventDefault();
        // }, {
        //     passive: false
        // })

        mainRef.current?.addEventListener('touchstart', (e: any) => {
            e.stopPropagation();
            blurHandle()
        })
        return () => {
            mainRef.current?.removeEventListener('touchstart', (e: any) => {
                e.stopPropagation();
                blurHandle()
            })
        }

    }, [])

    //网络错误重试
    const resetApiHandle = () => {
        if (isError.current) {
            sendMessage(currInputValue.current)
        }

    }
    const scrollToBottom = () => {
        chatContainer.current!.scrollIntoView({ behavior: "smooth" });
    };

    const blurHandle = () => {
        // handleScroll()

        inputRef.current.blur();
        if (judgeClient() == 'IOS') {
            setTimeout(() => {
                const dom = document.querySelector(".input-container");
                if (dom) {
                    dom.style.paddingBottom = "0px"
                }

            }, 100)
            window.scrollTo(0, 0); //解决白边问题，ios

        } else {
            setTimeout(() => {
                setCoinShow(true)
            }, 100)

        }
    }

    const focusHandle = () => {
        setActionBtn(false)
        if (judgeClient() == 'IOS') {
            setTimeout(() => {
                scrollToBottom();
            }, 200)
            setTimeout(() => {
                const dom = document.querySelector(".input-container");
                if (dom) {
                    dom.style.paddingBottom = "80px"
                }

            }, 100)
            inputRef.current?.focus();

        } else {
            setTimeout(() => {
                scrollToBottom();
            }, 400)
            setTimeout(() => {
                setCoinShow(false)
            }, 100)

        }
    }

    useEffect(() => {
        // const dom = document.querySelector(".chats-content")
        // dom?.addEventListener("scroll", scrollHandle);

        // return () => {
        //     dom?.removeEventListener("scroll", scrollHandle);
        // }
    })

    //当滚动条距离顶部小于112px的时候，隐藏头部人物角色信息
    // const scrollHandle = () => {
    //     const dom = document.querySelector(".chats-content")
    //     const newScrollTop = dom?.scrollTop || window.pageYOffset || document.body.scrollTop;
    //     if (dom!.scrollHeight > dom!.clientHeight && newScrollTop == 0) {
    //         if (headerShow) {
    //             setHeaderShow(false)
    //         }
    //     } else {
    //         setHeaderShow(true)
    //     }
    // }




    //点赞
    const likeHandle = async (flag: boolean) => {
        if (likeLoading) return

        setLikeLoading(true)

        try {
            setCharacterInfo({ ...characterInfo, is_like: flag, like_count: flag ? characterInfo.like_count + 1 : characterInfo.like_count - 1 })
            const { code } = await postLike(characterInfo.id, flag)
            if (code == 0) {
                getCharacter()
            }
            setLikeLoading(false)
        } catch (e) {
            setLikeLoading(false)
        }
    }
    let timer: any = null
    const getCharacter = async () => {
        try {
            const { code, data } = await getCharacterInfo(currCharacterInfo.id);
            clearInterval(timer)
            if (code == "0") {

                if (data.mint_state == 2) {
                    timer = setInterval(() => {
                        getCharacter()
                    }, 30000)
                    // 
                }
                if (data.mint_state !== 2) {
                    clearInterval(timer)

                }
                setCharacterInfo({ ...data })
                data && window.localStorage.setItem("currCharacterInfo", JSON.stringify(data))

            }
        } catch (e) {
            console.log("like error" + e)
        }
    }

    useEffect(() => {
        return () => {
            clearInterval(timer)
        }
    }, [])






    //返回角色页
    const toCharacter = () => {
        if (!isAllowSay) {
            return false;
        }
        window.localStorage.setItem("characterList", JSON.stringify([]))
        dispath(changeCharacterList([]))
        if (searchParams.get("key") === 'record') {
            navigate("/agents-records")
        } else {
            navigate(`/agents?id=${sessionStorage.getItem('avatarListId')}`)
        }

    }

    //聊天动作
    const actionHandle = async () => {
        await getActionCountHandle()
        if (!isAllowSay) {
            setIsTalkMessage(true)
            setMessageText(t("talk.finis"))
            setTimeout(() => {
                setIsTalkMessage(false)
            }, 900)
            return false;
        }
        setActionBtn(prev => prev = !prev)

        if (!actionBtn) {
            if (isGetActionList) {
                if (actionCount.current == 0) {
                    setCoinAction(true)
                } else {
                    await getActionListHandler()
                }
            }

        }
        // setTimeout(() => { setActionBtnLoading(false) }, 4000)
    }

    const regenerateHandle = async () => {
        // await getActionCountHandle()
        if (actionCount.current > 0) {
            await getActionListHandler()
        } else {
            setCoinAction(true)
        }
    }
    const getActionListHandler = async () => {
        try {
            setActionBtnLoading(true)

            const { code, data } = await getActionList(currID)
            await getActionCountHandle()
            if (code == "0") {
                if (data && data.msg != null) {
                    dispath(changeActionList({ id: currID, list: data?.msg }))
                    setGetActionList(false)
                    setActionList((prev: any) => [...data?.msg])

                }
                setActionBtnLoading(false)

            } else if (code == '65547') {
                setText(t("other.attention"))
                setPromptText(t("talk.insuf"))
                setActionBtn(false)
                setPointsDialog(true)
            }




        }
        catch (e) {
            // setActionBtnLoading(false)
        }
    }

    const getActionCountHandle = async () => {
        try {
            const { code, data } = await getActionCount(currID)
            if (code == 0) {
                actionCount.current = data.count
                // setActionCount(data.count)
            }
        }
        catch (e) {
            // setTimeout(() => {
            //     setActionBtn(false)
            // }, 3000)
        }
    }


    //--------------------金币进度条end---------------------

    //表情弹窗消失
    document.addEventListener("click", useCallback((e) => {
        e.stopPropagation();
        setActionBtn(false)
        if (emoji) {
            setEmoji(false);
        }
        if (actionBtn) {

        }
        if (menuList) {
            setMenuList(false)
        }
    }, []))


    //表情
    const [emoji, setEmoji] = useState(false);
    const emojiHandle = (e: any) => {
        e.nativeEvent.stopImmediatePropagation();
        setEmoji(!emoji)
    }
    const sendMessageEmoji = (e: any) => {
        const newText = inputValue + e.alt;
        setInput(newText);
        setEmoji(!emoji);
    }


    // ------------------------------语音相关-------------------------------start

    const audioRef = useRef<any>(null);
    const audioHandle = () => {
        setDialog(true)
        if (audioRef.current) {
            // audioRef.current!.deleteRecord();
            audioRef.current.openrecordingdevice();
        }

    }

    //关闭语音
    const closeAudioDialog = () => {
        setDialog(false);
        if (audioRef.current) {
            audioRef.current!.closerecordingdevice();
        }
    }

    //语音组件的base64和音频url
    const sendAudioHandle = (audioData: any) => {
        if (!isAllowSay) {
            return false;
        }
        const item: Message = {
            id: uuidv4(),
            status: "success",
            content: "",
            direction: "right",
            type: "audio",
            text: "",
            audioUrl: audioData.audio,
            durations: audioData.durations
        }
        dispath(addChatList({ id: characterInfo.id, item }))
        scrollToBottom();
        closeAudioDialog();
        sendMessage(audioData.base64String, "audio")
        if (audioRef.current) {
            audioRef.current!.closerecordingdevice();
        }

    }

    //----------------------------语音相关---------------------------------------------end

    //---------------------------切换背景（start）------------------------------------------

    const changeBackgroundHandle = () => {
        if (!isAllowSay) {
            return false;
        }

        navigate("/change-backgroud")
    }
    const navigate = useNavigate()
    const getCoinAnimation = (x: any, y: any) => {
        const total = document.getElementsByClassName('total_1')[0] // 获取金币最终飞向
        const R = 100; // 扩散半径
        const time = 0.25; //扩散过度时间
        const time2 = 1; // 收集过度时间
        const w = 26; // 金币大小
        const Num = 8 //金币数量

        const screenWidth = window.innerWidth;
        const pcX = screenWidth > 768 ? screenWidth > 1536 ? (screenWidth / 2) - 220 : screenWidth > 1920 ? (screenWidth / 2) - 250 : (screenWidth / 2) - 187.5 : 0
        setlits((x - pcX), y)

        if (audioRef.current) {
            // AudioRef.current.currentTime = 0;
            audioRef.current.play()
        }

        function setlits(X: any, Y: any) {
            var species = document.createElement('div');
            species.className = 'species'
            for (let i = 0; i < Num; i++) {
                var img = document.createElement('img');
                img.className = 'speciesstyle'
                img.style.width = w + 'px',
                    img.style.height = w + 'px',
                    img.style.left = X + 'px',
                    img.style.top = Y + 'px',
                    img.style.transform = 'translate(0%, 0%)',
                    img.style.transition = `${time}s`
                img.src = coin
                species.appendChild(img);
            }
            talkRef.current.appendChild(species)
            setTimeout(() => {
                clickss(X, Y)
            }, 0)
        }
        // 计算金币扩散范围和坐标
        function clickss(X: number, Y: number) {
            const specielist: any = document.getElementsByClassName('speciesstyle')
            const num = specielist.length
            const center = {
                x: X,
                y: Y
            }
            for (let i = 0; i < num; i++) {
                const xz = center.x + Math.floor(Math.random() * ((R * 1.1) - (R * 0.6) + 1)) + (0.6 * R) * Math.sin(2 * Math.PI * i / num)
                const yz = center.y + Math.floor(Math.random() * ((R * 1.1) - (R * 0.6) + 1)) + (0.6 * R) * Math.cos(2 * Math.PI * i / num)
                specielist[i].style.transform = `translate(${xz - (X + w / 2)}px, ${yz - (Y + w / 2)}px)`
            }
            setTimeout(() => {
                for (let i = 0; i < num; i++) {
                    specielist[i].style.transition = `${time2}s`
                    specielist[i].style.transform = `translate(0,0)`
                    specielist[i].style.left = Math.floor(total?.getBoundingClientRect().x) - coinMovementOffset() + 'px'
                    specielist[i].style.top = Math.floor(total?.getBoundingClientRect().y) + 'px'
                }
                // 结束清除蒙层
                setTimeout(() => {
                    remove()
                }, (Number(time2) + 0.5) * 500) //飞行时间结束

            }, (Number(time) + 0.5) * 500) //扩散时间结束
        }        // 清除dom
        function remove() {
            const species = document.getElementsByClassName('species')[0].remove()
        }
    }

    const coinCapDialog = () => {
        return (
            <div className='flex flex-col items-center justify-around pt-[42px]'>
                <p className='text-[#333] text-[20px] leading-[24px] font-bold'>{t("talk.congr")}</p>
                {Array.isArray(tasksData) &&
                    <p className='text-sm leading-[18px] mt-[20px] font-medium text-[#333]'>
                        {t("talk.earne")} {formatNumber(tasksData?.find((el: any) => el.code == 'chats')?.points)} {t("talk.goldc")}
                    </p>
                }
                <p className='text-sm leading-[18px] mb-[20px] font-medium text-[#333]'>for today!</p>
                <div className='bg-gradient-to-r button_shadow text-[#fff] from-[#00E49F] to-[#54ADFF] w-[174px] h-[36px] rounded-[10px]' onClick={(event) => { event.stopPropagation(); setCoinCap(false); }}>
                    {t("other.ok")}
                </div>
                <p className=' font-normal text-[12px] leading-[15px] mt-[5px] text-[#888]'>{t("talk.tasks")}</p>
            </div>
        )
    }


    // ------------------------ 滑动 -----------------------
    useLayoutEffect(() => {
        if (judgeClient() == 'Android') {
            document.addEventListener('touchstart', touchStartHandle);
            return () => {
                document.removeEventListener('touchstart', touchStartHandle);
                // window.scrollTo(0, 0);
            }
        }

    })

    const touchStartHandle = useCallback(() => {
        window.scrollTo(0, 1);
        // ensureDocumentIsScrollable();
    }, [])

    const ensureDocumentIsScrollable = () => {
        const isScrollable = document.documentElement.scrollHeight > window.innerHeight;
        if (!isScrollable) {
            document.documentElement.style.setProperty(
                "height",
                "calc(100% + 0.5px)",
                "important"
            );


        }
    }



    const getSaveLogs = useCallback(() => {
        searchSaveLogs(characterInfo.id).then((res: any) => {
            console.log(res)
            setSaveLogs(res.data)
        })
    }, [])

    useEffect(() => {
        getSaveLogs()
    }, [addCount])

    const [reportIndex, setReportIndex] = useState<any>([])
    async function reportPost() {
        try {
            await reportCreateAvatar({ id: characterInfo.id, type: reportIndex })
            setReport(false)
        } catch {
            setReport(false)
        }
        setReportIndex([])
        navigate(`/agents?id=${sessionStorage.getItem('avatarListId')}`)

    }

    function reportText() {
        return (
            <div className=' pt-12 px-[14px] relative'>
                <CloseComp position="absolute" top={14} right={16} callBack={() => { setReport(false) }}></CloseComp>
                <p className=' text-center text-[20px] mb-5 leading-6 font-bold text-[#333333]'>{t("talk.ria")}</p>
                {card_report.map((el: any, index: number) =>
                    <div key={`${index}-Inappropriate`} className='flex mt-[10px] gap-[10px]' onClick={() => {
                        if (reportIndex.includes(index + 1)) {
                            setReportIndex(reportIndex.filter((el: any) => el != index + 1))
                        } else {
                            setReportIndex([...reportIndex, index + 1])
                        }
                    }}>
                        <div style={{ border: `${reportIndex.includes(index + 1) ? '' : '1px solid #333333'}` }}
                            className='w-5 flex-shrink-0 rounded-full h-5'>
                            {reportIndex.includes(index + 1) && < img className=' h-5 w-5' src={selectActive} alt="" />}
                        </div>
                        <p className='text-[14px] leading-[18px] text-[#333] font-semibold'>{el}</p>
                    </div>
                )}
                <div className='h-[30px]'></div>
                <ButtonComp title={t("other.ok")} callBack={() => { reportPost() }}></ButtonComp>
            </div>
        )
    }

    const funPaySaveLogs = async () => {
        const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
        });
        try {
            // let data: any = {}
            // let code = ''
            // let msg = ''
            // if (chatLogPay || saveLogs.persistent_type == 1) {
            //     const res = await getSaveLogsLink(characterInfo.id, 'Save Chat Logs', 'Save Chat Logs', 9)
            //     data = res.data
            //     code = res.code
            //     msg = res.msg
            // } else {
            //     const res = await getSaveLogsLink(characterInfo.id)
            //     data = res.data
            //     code = res.code
            //     msg = res.msg
            // }
            const { code, data, msg } = await getSaveLogsLink(characterInfo.id, '', '', 0)
            if (code == '0') {
                if (!data.link) {
                    const { code, msg } = await paySaveLogs(characterInfo.id, data.order_id)
                    if (code != '0') {
                        setText(t("other.attention"))
                        setPromptText(msg)
                        setPointsDialog(true)
                    }
                    getSaveLogs()
                }
            } else {
                setText(t("other.attention"))
                setPromptText(msg)
                setPointsDialog(true)
            }
        }
        catch (e) {
            setText(t("other.neterror"))
            setPromptText(t("talk.retry"))
            setPointsDialog(true)
        }
        toast.clear()
        setSaveChatLogPayDialog(false)
    }

    function saveChatLogPay() {
        return (
            <div key={addCount} className='pt-6 px-[14px] relative'>
                <CloseComp top={0} right={14} position='absolute' callBack={() => { setSaveChatLogPayDialog(false) }}></CloseComp>
                {/* <img className=' top-3 right-[14px] absolute w-5 h-5' onClick={() => setSaveChatLogPayDialog(false)} src={close} alt="" /> */}
                <p className=' text-center text-[20px] my-[20px] leading-6 font-bold text-[#333333]'>{t("other.attention")}</p>
                {
                    chatLogText.map((list: any, i: number) =>
                        <div style={{ background: 'linear-gradient( 135deg, rgb(87, 255, 61,0.2) 0%, rgb(84, 173, 255,0.2) 100%)' }} className='relative px-[6px] rounded-[6px] pt-1  mt-[20px] cursor-pointer' onClick={() => {
                            if (saveLogs?.persistent_type == 0) {
                                setSaveLogsTypeActive(i)
                            }

                        }}>
                            <div className={`${!!i ? 'w-[101px] from-[#005FC4] to-[#D43BA6]' : 'from-[#FB5445] to-[#FBB11B] w-[70px]'} absolute left-0 top-0  h-[26px] text-center bg-gradient-to-r  rounded-br-[6px]  rounded-tl-[6px] text-[12px] leading-[26px] text-[#FFFFFF]`}>{!!i ? t("talk.probe") : t("talk.benef")}</div>
                            {
                                saveLogs?.persistent_type == 2 ? <div className={`${'w-[83px] from-[#EF4444] to-[#E88585]'} absolute right-0 top-0  h-[26px] text-center bg-gradient-to-r  rounded-tr-[6px]  rounded-bl-[6px] text-[12px] leading-[26px] text-[#FFFFFF]`}>{t("talk.purch")}</div> :
                                    saveLogs?.persistent_type == 1 && i == 0 ? <div className={`${'w-[83px] from-[#EF4444] to-[#E88585]'} absolute right-0 top-0  h-[26px] text-center bg-gradient-to-r  rounded-tr-[6px]  rounded-bl-[6px] text-[12px] leading-[26px] text-[#FFFFFF]`}>{t("talk.purch")}</div> : ''
                            }
                            <img className={`${i == saveLogsTypeActive && saveLogs?.persistent_type != 2 ? '' : 'hidden'} h-[18px] absolute right-1 top-1`} src={selectActive} alt="" />
                            <div className='mt-[30px]'>
                                {list.map((el: any, index: number) =>
                                    <div key={`${index}-Inappropriate`} className='flex pb-[10px] gap-[5px] items-start' >
                                        <svg className=' flex-shrink-0 mt-[2px]' width="14px" height="13px" viewBox="0 0 14 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <defs>
                                                <linearGradient x1="-2.72351586e-14%" y1="-1.94289029e-13%" x2="100%" y2="100%" id="linearGradient-1">
                                                    <stop stopColor="#00E49F" offset="0%"></stop>
                                                    <stop stopColor="#54ADFF" offset="100%"></stop>
                                                </linearGradient>
                                            </defs>
                                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <g transform="translate(-62.000000, -318.000000)" fill="url(#linearGradient-1)">
                                                    <path d="M68.5346589,329.244644 L66.0911901,330.529252 C65.6023455,330.786253 64.9977184,330.598306 64.7407176,330.109462 C64.6383785,329.914801 64.6030638,329.691833 64.6402407,329.475075 L65.1069017,326.754233 C65.1625396,326.429839 65.0549911,326.098839 64.8193051,325.869102 L62.8424973,323.94219 C62.4470137,323.556689 62.4389214,322.923576 62.8244226,322.528092 C62.9779313,322.370609 63.1790737,322.268121 63.3967107,322.236497 L66.1285918,321.839531 C66.454302,321.792203 66.7358675,321.587633 66.8815296,321.29249 L68.1032639,318.816986 C68.3476862,318.321732 68.9473121,318.118393 69.4425657,318.362815 C69.6397783,318.460146 69.7994058,318.619773 69.8967361,318.816986 L71.1184704,321.29249 C71.2641325,321.587633 71.545698,321.792203 71.8714082,321.839531 L74.6032893,322.236497 C75.1498342,322.315914 75.5285156,322.823357 75.449098,323.369902 C75.4174735,323.587539 75.3149863,323.788682 75.1575027,323.94219 L73.1806949,325.869102 C72.9450089,326.098839 72.8374604,326.429839 72.8930983,326.754233 L73.3597593,329.475075 C73.4531203,330.019412 73.0875325,330.536368 72.5431961,330.629729 C72.3264384,330.666906 72.1034703,330.631591 71.9088099,330.529252 L69.4653411,329.244644 C69.1740171,329.091486 68.8259829,329.091486 68.5346589,329.244644 Z" id="星形备份-3"></path>
                                                </g>
                                            </g>
                                        </svg>
                                        <p className='text-[14px] leading-[18px] text-[#333] font-semibold'>{el}</p>
                                    </div>
                                )}
                            </div>

                        </div>
                    )
                }

                {
                    saveLogs?.persistent_type != 2 ? <>
                        {
                            saveLogsTypeActive == 0 ?

                                <div className='h-[40px] w-full mt-[20px]'>
                                    <ButtonComp callBack={funPaySaveLogs}>

                                        <span >200k</span>
                                        <img className='w-4 h-4 ml-2' src={coin} alt="" />

                                    </ButtonComp>

                                </div>
                                : <div className={`h-[40px] w-full mt-[20px] grid ${payList.length == 2 ? 'grid-cols-2' : 'grid-cols-3'}  gap-1`}>
                                    {
                                        payList.map((item: any) => <ButtonComp width={payList.length == 2 ? 118 : 92} title={`${item.pay_price} ${item.price >= 10 ? payImgType[(item.pay_type - 2)]?.names : payImgType[(item.pay_type - 2)]?.name}`} callBack={() => { payHandle(item) }}>
                                        </ButtonComp>)
                                    }
                                </div>
                        }
                    </>
                        :
                        <p className='text-center mt-4 text-[14px] mx-2'>{t("talk.unloc")}</p>

                }
            </div>
        )
    }

    const [points, setPoints] = useState('')
    const [menuList, setMenuList] = useState(false)
    const [languageValue, setLanguageValue] = useState("");
    const [languageList, setLanguageList] = useState(false)
    const logOption = useRef<any>(null)
    const [isShare, setIsShare] = useState(false)
    const [isResetChat, setIsResetChat] = useState(false)


    const [showIntimacyPopup, setShowIntimacyPopup] = useState(false)
    // 亲密度
    const [intimacyList, setIntimacy] = useState<any>()
    //亲密度进度条
    const prossesLin = useMemo(() => {
        let level, line;
        if (intimacyList?.level == 1) {
            level = 0
            line = (intimacyList?.intimacies) / (intimacyList?.list[level]?.start)
        } else {
            level = intimacyList?.level - 2
            line = (intimacyList?.intimacies - intimacyList?.list[level]?.start) / (intimacyList?.list[level]?.end - intimacyList?.list[level]?.start)
        }


        if (isNaN(line)) {
            return 0
        }
        if (line.toFixed(2) >= "1" || intimacyList?.level == 10) {
            return 100
        }
        return Number(line.toFixed(2)) as number * 100
    }, [intimacyList])
    const prossesLin1 = useMemo(() => {
        const line = (characterInfo?.intimacy - characterInfo?.query_intimacy_list_item?.start || 0) / (characterInfo?.query_intimacy_list_item?.end - characterInfo?.query_intimacy_list_item?.start || 0)
        if (isNaN(line)) {
            return 0
        }
        if (line.toFixed(2) >= "1" || intimacyList?.level == 10) {
            return 100
        }
        return Number(line.toFixed(2)) as number * 100
    }, [characterInfo])


    const intimacyHandle = async () => {
        await getAvatarIntimacyList()

    }

    const getAvatarIntimacyList = async () => {
        const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
        })
        try {
            const { code, data } = await apiAvatarIntimacy(currID)
            toast.clear()
            if (code == '0') {
                let list = data.list.filter((item: any) => item.level != 1)
                let obj = {
                    ...data,
                    list
                }
                setIntimacy(obj)
                setShowIntimacyPopup(true)
            }
        } catch (e) {
            toast.clear()
        }

    }

    const [shareDialog, setShareDialog] = useState(false)
    const { shopCount } = useSelector((state: any) => state.lottery)
    const [showPayDialog, setShowPayDialog] = useState(false)


    const [payDownLoad, setPay] = useState<any>([])

    const downLoadHandle = async (item: any) => {
        setMenuList(false)
        if (shopCount[3] > 0) {
            const params = {
                url: item.main_images[0],
                file_name: item.link
            }
            try {
                downloadFile(params)
                await updateDownLoadCount(item.id)
                getCardInoHandle()
            } catch (e) {
            }
        } else {
            setShowPayDialog(true)
            console.log("单次付费")
        }

    }
    useEffect(() => {
        getCardInoHandle()
        getPayConfigHandle()
    }, [])

    const getPayConfigHandle = async () => {
        const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
        })
        try {
            const { code, data } = await getShopPayConfig(10)
            if (code == 0) {
                let list = data.filter((item: any) => item.count == 1)
                list = list.map((item: any) => {
                    return {
                        ...item,
                        title: "Image Download"
                    }
                });
                setPay(list)
            }
            toast.clear()
        } catch (e) {
            toast.clear()
        }

    }
    const getCardInoHandle = async () => {
        dispatch(changeShopCount({ type: 0, count: await getShopPayCountHandle(3) }))
        dispatch(changeShopCount({ type: 2, count: await getShopPayCountHandle(11) }))
        dispatch(changeShopCount({ type: 3, count: await getShopPayCountHandle(10) }))
    }

    return (

        <div className={`mobile-tall-content talk-box w-full h-full max-md:px-4 box-border relative bg-no-repeat bg-cover bg-center overflow-auto`} style={{ overflow: 'scroll-y', backgroundImage: `url(${characterInfo.bg_image})` }} ref={talkRef}>
            {/* <div className={`talk-box w-full h-[100vh] px-4 box-border relative bg-no-repeat bg-cover bg-center`} style={{ backgroundImage: `url(${bg})` }} ref={talkRef}> */}
            {/* 头部人物信息和点赞 */}
            {headerShow && <div className='w-full h-[112px] px-4 max-md:px-0 py-3 z-[200] sticky top-0 left-0 bg-gradient-to-b from-[#32726E]/0 to-[#fff]/[0] overflow-hidden'>
                <div className="avatar h-11 mb-2">
                    <Back isLeft={false} callback={() => toCharacter()}>
                        <div className='flex max-md:pl-[10px] items-center justify-between w-full'>
                            <div className='bg-[#000]/[.4] px-2 rounded-full flex items-center h-full'>
                                <div className="img h-9 w-9 rounded-full" onClick={() => {
                                    if (!localStorage.getItem('token')) {
                                        dispatch(changeLoginState(true))
                                        return
                                    }
                                    if (characterInfo.mint_state == 3 && characterInfo?.state == 1) {
                                        setCardUrl(characterInfo?.main_image);
                                        setCardLevel(9)
                                        setDrawCard(true);
                                        setProperty({
                                            is_my: characterInfo?.is_my,
                                            property: characterInfo?.property,
                                            power: characterInfo?.power
                                        })
                                    } else {
                                        if (!characterInfo.is_customized) {
                                            if (characterInfo.link == "Comet_1") {
                                                window.open('https://x.com/Comet_AI_Agent', "_blank")
                                            } else if (characterInfo.link == "Orion_1") {
                                                window.open('https://x.com/orion_agent', "_blank")
                                            } else {
                                                dispath(changeHomePage(
                                                    {
                                                        showHomePage: true,
                                                        id: characterInfo.account_id,
                                                    }
                                                ))
                                            }
                                        } else {
                                            window.open('https://x.com/The_StarAI', "_blank")
                                        }
                                    }


                                }}>
                                    <img className='w-full h-full rounded-full' src={characterInfo.image} alt="" />
                                </div>
                                <div className="text text-base text-white ml-3 px-2 w-[160px]">
                                    <div className='text-base text-white flex item-center justify-start'>
                                        <p onClick={() => {
                                            if (!localStorage.getItem('token')) {
                                                dispatch(changeLoginState(true))
                                                return
                                            }
                                            if (characterInfo.mint_state == 3 && characterInfo?.state == 1) {
                                                setCardUrl(characterInfo?.main_image);
                                                setCardLevel(9)
                                                setDrawCard(true);
                                                setProperty({
                                                    is_my: characterInfo?.is_my,
                                                    property: characterInfo?.property,
                                                    power: characterInfo?.power
                                                })
                                            }
                                        }} className='truncate'>{characterInfo?.name}</p>
                                        {characterInfo?.state == 1 && characterInfo?.mint_state == 3 && <img className='w-[42px] h-[20px] ml-2' src={nftImg} alt="" />}
                                    </div>

                                    <div className='flex items-center' onClick={() => {
                                        if (!localStorage.getItem('token')) {
                                            dispatch(changeLoginState(true))
                                            return
                                        }
                                        intimacyHandle()
                                    }}>
                                        <svg width="12px" height="12px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <defs>
                                                <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
                                                    <stop stopColor="#00E49F" offset="0%"></stop>
                                                    <stop stopColor="#54ADFF" offset="100%"></stop>
                                                </linearGradient>
                                            </defs>
                                            <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <g id="亲密度弹窗" transform="translate(-23.000000, -502.000000)" fill="url(#linearGradient-1)" fillRule="nonzero">
                                                    <g id="编组备份-2" transform="translate(23.000000, 502.000000)">
                                                        <path d="M19.9902134,6.86327482 C19.9746581,7.16325712 19.9368811,7.45573988 19.8879932,7.74572278 C19.0342556,6.77187993 17.8705502,6.22124084 16.6547245,6.21581302 C15.3041874,6.24217604 14.0389173,6.96353613 13.2214597,8.17319756 C12.6103608,7.8232182 12.1081486,7.59323178 11.42594,7.59323178 C11.1059464,7.59323178 10.5348467,7.51073665 10.2192975,7.59323178 C7.84156721,8.21319521 6.55492624,11.0380286 7.00158399,14.0278522 C7.27713404,15.8777431 8.2837806,17.3201581 9.6459756,18.3400979 C7.60379417,19.4150345 6.1993778,20 6.1993778,20 C6.1993778,20 5.63050027,17.4951477 4.60385411,15.6502566 C2.81722315,12.4454456 -0.240493533,11.2905137 0.0150569031,6.37330373 C0.206164211,2.67102209 2.90166591,0.688639022 5.25939658,0.666140335 C6.84380937,0.648641376 8.68821695,1.58358623 9.24376141,3.18599172 C10.3948495,1.25610556 12.388143,-0.216307601 14.999202,0.0261780918 C18.0724739,0.313661139 20.1613211,3.13849451 19.9902134,6.86077497 L19.9902134,6.86327482 Z M8.20822655,14.0278522 C7.88601078,11.8754792 8.83043635,9.62311205 10.5770681,9.16813887 C10.8059524,9.11064227 11.0326146,9.08064404 11.2570545,9.08064404 C12.1659252,9.08064404 13.0236859,9.54811646 13.6392291,10.3255706 C13.9792224,9.06564491 14.8392052,8.05820435 15.9858489,7.75822205 C16.8634724,7.54147304 17.7816991,7.74386965 18.521715,8.31718063 C19.261731,8.89049161 19.7572593,9.78337049 19.8902154,10.7830436 C20.2746521,13.8053654 18.685795,14.5828195 17.4591528,16.7826898 C16.3547305,18.7675727 17.0591608,19.5400271 17.0591608,19.5400271 C17.0591608,19.5400271 8.8948795,18.6350805 8.20822655,14.0278522 Z" id="形状"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <span className='text-xs mx-1 text-transparent bg-clip-text bg-gradient-to-r from-[#00E49F] to-[#54ADFF]'>{t("talk.lv")}{characterInfo?.query_intimacy_list_item?.level || 1}</span>
                                        <div className=' bg-[rgba(166,166,166,0.48)] my-[10px] rounded-[8px] flex-1 h-1'>
                                            <div className='h-1 w-[0%] rounded-[8px]' style={{ background: 'linear-gradient( 135deg, #00E49F 0%, #54ADFF 100%)', width: prossesLin1 + '%', }}>

                                            </div>
                                        </div>
                                    </div>
                                    {/* <p className={`${characterInfo.account_id ? '' : 'hidden'} text-xs text-[#a6a6a6]`}>By @{characterInfo.is_customized ? 'StarAI' : characterInfo.account_id}</p> */}
                                </div>
                            </div>
                            <div className='text-white flex  items-center'>

                                <div className=' mr-3 relative' onClick={() => {
                                    setShareDialog(true)
                                }}>
                                    {Array.isArray(shareStatusList?.avatarDomainShare) && !shareStatusList?.avatarDomainShare[0].status &&
                                        <div className=' absolute p-[4px] pt-[1px] pb-[2px] w-12 top-[-18px] left-[50%] -translate-x-[50%] ' style={{ background: 'linear-gradient( 125deg, #EF4444 0%, #E88585 100%)', borderRadius: '0px 9px 0px 9px' }}>
                                            <p className=' text-[12px] text-[#fff] leading-4 font-normal  flex items-center gap-1'> +5k <img src={coins} className='w-[14px] h-[10px]' alt="" /></p>
                                        </div>}
                                    <img src={share} className='w-[18px] h-[18px]' alt="" />
                                </div>

                                <div className='flex items-center justify-between' onClick={async () => {
                                    if (!localStorage.getItem('token')) {
                                        dispatch(changeLoginState(true))
                                        return
                                    }
                                    if (saveLogs?.persistent_type == 1) {
                                        setSaveLogsTypeActive(1)
                                    }
                                    try {
                                        const res = await getShopPayConfig(9)
                                        if (res.code == 0) {
                                            setPayList(res.data)
                                        }
                                    } catch (e) {
                                        console.log("��� ~ getShopPayConfig error ~ e:", e)
                                    }
                                    setSaveChatLogPayDialog(true)
                                    // if (saveLogs?.persistent_type == '2') {
                                    //     setPointsDialog(true)
                                    //     setText('Attention')
                                    //     setPromptText('All chat logs with this Agent have been saved.')
                                    // } else {

                                    // }
                                }}>
                                    {/* <span className='text-white'>Save Chat Logs</span> */}
                                    <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <g transform="translate(-337.000000, -112.000000)" fillRule="nonzero">
                                                <g transform="translate(337.000000, 112.000000)">
                                                    <rect fill="#000000" opacity="0" transform="translate(11.000000, 11.000000) rotate(-360.000000) translate(-11.000000, -11.000000) " x="0" y="0" width="22" height="22"></rect>
                                                    <g transform="translate(3.000000, 3.000000)" fill="#FFFFFF">
                                                        <path d="M10.5068616,0 C11.0408937,0 11.5528584,0.21377467 11.9282808,0.593328161 L15.4207296,4.12405826 C15.7916152,4.49835766 15.9997863,5.00390718 16,5.53083353 L16,14.7501767 C16,15.4404351 15.4404254,16 14.7501552,16 L1.24984482,16 C0.559574584,16 0,15.440435 0,14.7501767 L0,1.25147832 C0,0.561219979 0.559574584,0.00165503399 1.24984482,0.00165502327 L10.5068616,0 Z M11.5826495,8.66601154 L4.41624714,8.66601154 C4.30573057,8.66601154 4.19974449,8.70993218 4.12162335,8.78810371 C4.0435022,8.86627525 3.99972406,8.97228855 3.99972406,9.0828032 L3.99972406,15.9988966 L5.3323219,15.9988966 L5.3323219,9.99886216 L10.6651955,9.99886216 L10.6651955,15.9988966 L11.998345,15.9988966 L11.998345,9.08445822 C11.998345,8.8731661 11.8402869,8.69552624 11.6303703,8.6707008 L11.5826495,8.66601154 L11.5826495,8.66601154 Z M5.41507482,3.62451513 L3.08171849,3.62451513 C3.03601533,3.62451513 2.99896559,3.66156423 2.99896559,3.7072666 L2.99896559,4.79048357 C2.99896559,4.83618595 3.03601532,4.87323507 3.08171849,4.87323507 L5.41507482,4.87323507 C5.46077799,4.87323507 5.49782774,4.83618596 5.49782774,4.79048357 L5.49782774,3.7072666 C5.49782774,3.66156422 5.46077799,3.62451513 5.41507482,3.62451513 L5.41507482,3.62451513 Z" id="形状"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>



                                <div className='text-white ml-3' onClick={(e) => {
                                    e.stopPropagation()
                                    setMenuList(!menuList)
                                }}>
                                    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                        <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <g id="人物聊天三个按钮" transform="translate(-341.000000, -56.000000)" fill="#FFFFFF" fillRule="nonzero">
                                                <g id="编组" transform="translate(341.000000, 56.000000)">
                                                    <path d="M17.2208518,1.78487866 L1.63820742,1.78487866 C1.24863332,1.78487866 0.859059226,1.33865246 0.859059226,0.892426255 C0.859059226,0.446200055 1.24863332,0 1.63820742,0 L17.2208518,0 C17.6104259,0 18,0.4462262 18,0.892426255 C18,1.33862631 17.6104259,1.78487866 17.2208518,1.78487866 L17.2208518,1.78487866 Z M17.3939958,9.59366722 L5.27416133,9.59366722 C4.97115925,9.59366722 4.66815718,9.14746716 4.66815718,8.70124096 C4.66815718,8.25501476 4.97115925,7.80881471 5.27416133,7.80881471 L17.3939958,7.80881471 C17.6969979,7.80881471 18,8.25501476 18,8.70124096 C18,9.14746716 17.6969979,9.59366722 17.3939958,9.59366722 Z M17.3939958,17.4024819 L5.27416133,17.4024819 C4.97115925,17.4024819 4.66815718,16.9562557 4.66815718,16.5100557 C4.66815718,16.0638556 4.97115925,15.6176033 5.27416133,15.6176033 L17.3939958,15.6176033 C17.6969979,15.6176033 18,16.0638295 18,16.5100557 C18,16.9562819 17.6969979,17.4024819 17.3939958,17.4024819 Z M1.81133371,17.4024819 L0.691867913,18 L0.905666857,16.7344364 L-5.41860487e-14,15.8381593 L1.25160081,15.6535161 L1.81133371,14.5020683 L2.37106661,15.6535161 L3.62266743,15.8381593 L2.71700057,16.7344364 L2.93079951,18 L1.81133371,17.4024819 Z M1.81133371,9.66804551 L0.691867913,10.2655636 L0.905666857,9 L-5.41860487e-14,8.10372289 L1.25160081,7.91907965 L1.81133371,6.76763186 L2.37106661,7.91907965 L3.62266743,8.10372289 L2.71700057,9 L2.93079951,10.2655636 L1.81133371,9.66804551 Z" id="形状"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>

                            </div>

                        </div>


                    </Back>

                </div>

                <div className="options !w-full h-7 flex justify-start items-center cursor-auto">
                    {
                        !characterInfo?.is_my || (characterInfo?.is_my && characterInfo?.mint_state == 3 && characterInfo?.state == 1) || (characterInfo?.is_my && characterInfo?.mint_state != 3 && characterInfo?.state != 1) ? <div className="inline-block py-1 px-2 rounded-full bg-[#000]/[.4] mr-2">
                            <p className={`text-xs text-[#fff]`} onClick={() => {
                                if (!localStorage.getItem('token')) {
                                    dispatch(changeLoginState(true))
                                    return
                                }
                                if (!characterInfo.is_customized) {
                                    if (characterInfo.link == "Comet_1") {
                                        window.open('https://x.com/Comet_AI_Agent', "_blank")
                                    } else if (characterInfo.link == "Orion_1") {
                                        window.open('https://x.com/orion_agent', "_blank")
                                    } else {
                                        dispath(changeHomePage(
                                            {
                                                showHomePage: true,
                                                id: characterInfo.account_id,
                                            }
                                        ))
                                    }
                                } else {
                                    window.open('https://x.com/The_StarAI', "_blank")
                                }
                            }}>
                                @{characterInfo?.is_customized ? 'StarAI' : characterInfo.link == "Comet_1" || characterInfo.link == "Orion_1" ? characterInfo.name : characterInfo?.account_name ? formatIdString(characterInfo?.account_name) : formatIdString(characterInfo?.account_id)}
                            </p>
                        </div>
                            : <></>
                    }

                    {/*  点赞 */}
                    <div className="inline-block py-1 px-2 = rounded-full  bg-[#000]/[.4] mr-2">
                        <div onClick={() => {
                            if (!localStorage.getItem('token')) {
                                dispatch(changeLoginState(true))
                                return
                            }
                            likeHandle(true)
                        }} className='flex items-center '>
                            <div className='relative'>
                                <svg width="14px" height="14px" viewBox="0 0 15 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                    <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="02-talk" transform="translate(-26.000000, -156.000000)" fill="#FFFFFF" fillRule="nonzero">
                                            <g id="编组" transform="translate(26.000000, 156.000000)">
                                                <path d="M10.273359,0.0502385068 C11.5326273,-0.151973142 12.7150195,0.259449789 13.6720334,1.22656591 C14.6444225,2.20962565 15.1105543,3.50494684 14.9778023,4.86365362 C14.8465504,6.20602791 14.1595405,7.53168085 13.0033987,8.7002309 C12.680894,9.02649163 11.8138814,9.90727893 10.5696133,11.1726572 C10.0101052,11.7419608 9.41459655,12.3474292 8.81458785,12.9587306 L8.23107937,13.552144 L7.999326,13.7881872 C7.72200649,14.0706043 7.277631,14.0706043 7.00031149,13.7881872 L4.98578223,11.7349612 L4.56015106,11.3025393 C3.70563963,10.4349697 2.85100221,9.56753357 1.99623883,8.7002309 C0.840097034,7.53168085 0.153462068,6.20641678 0.0222101567,4.86365362 C-0.110541771,3.50494684 0.355214992,2.20962565 1.32797912,1.22656591 C2.28499303,0.259449789 3.4673852,-0.151584279 4.72665348,0.0502385068 C5.66116705,0.199952899 6.60918081,0.682538795 7.50019375,1.45288742 C8.39158169,0.682927658 9.33922046,0.199952899 10.273734,0.0502385068 L10.273359,0.0502385068 Z" id="路径"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                <svg className={`svg-celebrate ${likeLoading ? 'talk_svg-celebrate_active' : ''}`} width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                                    <polygon points="10,10 20,20"></polygon>
                                    <polygon points="10,50 20,50"></polygon>
                                    <polygon points="20,80 30,70"></polygon>
                                    <polygon points="90,10 80,20"></polygon>
                                    <polygon points="90,50 80,50"></polygon>
                                    <polygon points="80,80 70,70"></polygon>
                                </svg>
                            </div>

                            <div className={`text-[#fff] ml-2 text-xs `}>{FormattingTwoNumber(characterInfo?.like_count?.toString())}</div>
                        </div>

                    </div>
                    {/* 交互 */}
                    <div className="inline-block py-1 px-2  rounded-full bg-[#000]/[.4] mr-2">
                        <div className='flex items-center'>
                            <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="02-talk" transform="translate(-86.000000, -156.000000)" fill="#FFFFFF" fillRule="nonzero">
                                        <g id="编组" transform="translate(86.000000, 156.000000)">
                                            <path d="M13.4446033,3.991571 C13.0855213,3.20443807 12.5728259,2.49659608 11.9364695,1.90939851 C11.2962168,1.30923481 10.5486733,0.834408569 9.73272368,0.509618683 C7.98460872,-0.169872894 6.04454252,-0.169872894 4.29642756,0.509618683 C3.47217771,0.831812937 2.71650023,1.30676642 2.06929981,1.90939851 C1.44193842,2.49925844 0.93738579,3.20682828 0.584547975,3.991571 C0.208010137,4.79337502 0.00865576538,5.66658485 0,6.5520016 C0.00958390004,8.16326605 0.637082869,9.70972466 1.75364391,10.8738218 L2.06929981,13.5625656 C2.09881321,13.8111555 2.30943437,13.9987898 2.5603201,14 C2.6463432,14.0001771 2.73093957,13.9780704 2.80583024,13.9358402 L4.84005717,12.769357 C6.45135688,13.2590774 8.18097184,13.1933346 9.75026012,12.5827197 C10.57451,12.2605254 11.3301875,11.7855719 11.9773879,11.1829399 C12.5965748,10.5966378 13.0949837,9.89527345 13.4446033,9.11826462 C14.1851322,7.48923325 14.1851322,5.62060237 13.4446033,3.991571 Z M3.97492618,7.31604808 C3.55846655,7.31604808 3.22085932,6.97919533 3.22085932,6.56366642 C3.22085932,6.14813751 3.55846657,5.81128478 3.9749262,5.81128478 C4.39138583,5.81128478 4.72899316,6.14813752 4.72899316,6.56366643 C4.72918901,6.97025246 4.40560892,7.30344081 3.9983081,7.31604808 L3.97492618,7.31604808 Z M6.9911937,7.31604808 C6.57473407,7.31604808 6.23712684,6.97919533 6.23712684,6.56366642 C6.23712684,6.14813751 6.57473408,5.81128478 6.99119372,5.81128478 C7.40765335,5.81128478 7.74526067,6.14813752 7.74526067,6.56366643 C7.74545653,6.97025246 7.42187644,7.30344081 7.01457562,7.31604808 L6.9911937,7.31604808 Z M10.0074612,7.31604808 C9.59100158,7.31604808 9.25339436,6.97919533 9.25339436,6.56366642 C9.25339436,6.14813751 9.5910016,5.81128478 10.0074612,5.81128478 C10.4239209,5.81128478 10.7615281,6.14813752 10.7615281,6.56366643 C10.7616389,6.97245706 10.4345931,7.30654134 10.0249977,7.31604808 L10.0074612,7.31604808 Z" id="形状"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <div className='ml-2 text-xs text-[#fff]'>{FormattingTwoNumber(characterInfo?.chat_count?.toString())}</div>
                        </div>
                    </div>

                    {/* 更换背景 */}
                    <div className="inline-block py-1 px-2  rounded-full bg-[#000]/[.4]">
                        <div className='flex items-center'>
                            <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="02-talk" transform="translate(-150.000000, -156.000000)" fill="#FFFFFF" fillRule="nonzero">
                                        <g id="编组-9" transform="translate(140.000000, 151.000000)">
                                            <g id="编组" transform="translate(10.000000, 5.000000)">
                                                <path d="M13.9648888,3.86428935 L13.145293,10.3580466 C13.0387455,11.1867954 12.7467645,11.7737311 12.2867663,12.1086364 C12.1279696,12.1994582 11.9538055,12.1086364 11.9538055,11.9235871 L11.9538055,5.42188288 C11.9538055,3.44650916 10.8893554,2.26809657 9.10775892,2.26809657 L2.67905394,2.26809657 C2.47415498,2.26809657 2.470057,2.06374756 2.48439993,1.97292578 C2.59197188,1.25770427 2.84707109,0.726396854 3.24355059,0.396032629 C3.65847099,0.0497745927 4.21784516,-0.0694289935 4.91142815,0.0384218702 L12.1238717,1.15893558 C12.8195036,1.26792172 13.3297021,1.55628087 13.6431975,2.01606613 C13.9546439,2.47585139 14.0632403,3.09684531 13.9648888,3.86428935 Z M10.9293107,5.42074761 L10.9293107,11.9814859 C10.9293107,13.3267836 10.3217853,14 9.10775892,14 L1.82155178,14 C0.607525426,14 0,13.3267836 0,11.9814859 L0,5.42074761 C0,4.07544999 0.607525426,3.40223355 1.82155178,3.40223355 L9.10775892,3.40223355 C10.3217853,3.40223355 10.9293107,4.07431472 10.9293107,5.42074761 Z M1.02347032,5.42074761 L1.02347032,10.8541606 L2.00288737,9.76884032 C2.11660656,9.64154875 2.27153565,9.56992883 2.43317519,9.56992883 C2.59481473,9.56992883 2.74974382,9.64154875 2.86346301,9.76884032 L3.43000864,10.3966459 C3.54995869,10.5252578 3.74034642,10.5252578 3.86029647,10.3966459 L6.85899279,7.07483928 C7.09889288,6.81761552 7.47966835,6.81761552 7.71956844,7.07483928 L9.90481588,9.50318662 L9.90481588,5.42074761 C9.90481588,4.70325555 9.75626413,4.5375058 9.10775892,4.5375058 L1.82155178,4.5375058 C1.17304656,4.5375058 1.02347032,4.70325555 1.02347032,5.42074761 Z M3.07450894,7.56641216 C3.45162321,7.56641216 3.75733471,7.22764439 3.75733471,6.8097532 C3.75733471,6.39186202 3.45162321,6.05309425 3.07450894,6.05309425 L3.06836197,6.05309425 C2.88776616,6.05369499 2.7147978,6.13384834 2.58757804,6.27588899 C2.46035828,6.41792965 2.38932964,6.61019856 2.39013944,6.81032084 C2.39013944,7.22810103 2.69749485,7.56641216 3.07450894,7.56641216 L3.07450894,7.56641216 Z" id="形状"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <div className='ml-2 text-xs text-[#fff]' onClick={() => {
                                if (!localStorage.getItem('token')) {
                                    dispatch(changeLoginState(true))
                                    return
                                }
                                changeBackgroundHandle()
                            }}>{t("talk.backg")}</div>
                        </div >

                    </div >
                    {
                        characterInfo.state == 1 && characterInfo?.is_my && characterInfo?.mint_state != 3 && <Mint isNoMint={characterInfo?.main_images_nsfw[0]} status={characterInfo?.mint_state} cardId={characterInfo?.id} cardState={""} type='agents' callback={(id: string) => {
                            // getCardInoHandle(id)
                            // updateHandle()
                            getCharacter()
                        }}></Mint>
                    }

                </div >

            </div >}


            {/* 重置聊天与语言选择以及log分享 */}
            <div className={`${menuList ? '' : 'hidden'} w-[180px] z-[1000] min-h-[156px] bg-[#333] absolute right-4 top-[56px] rounded-xl px-[10px] py-[20px] flex flex-col`}>

                {/* 举报 */}
                <div className={`${!characterInfo.is_customized ? '' : 'hidden'} flex items-center justify-between mb-[20px]`} onClick={() => {
                    setReport(true)
                }}>
                    <span className='text-white'>{t("talk.repor")}</span>
                    <img className='w-[18px] h-[18px]' src={report} alt="" />
                </div>
                {/* 重置聊天 */}
                <div className='flex items-center justify-between' onClick={() => {
                    setIsResetChat(true)
                    setPointsDialog(true)
                    setText(t("other.attention"))
                    setPromptText('Once reset, the chat history will be deleted, and the AI Agent will start a brand new conversation with you.')
                }}>
                    <span className='text-white'>{t("talk.reset")}</span>
                    <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="人物聊天三个按钮" transform="translate(-337.000000, -112.000000)">
                                <g id="编组-69" transform="translate(337.000000, 112.000000)">
                                    <rect id="矩形" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="22" height="22"></rect>
                                    <g id="编组" transform="translate(1.000000, 2.000000)" fill="#FFFFFF" fillRule="nonzero">
                                        <path d="M19.8811584,7.9817808 L16.257619,3.33931471 C15.9245559,2.90626918 15.3097388,2.8299696 14.8843193,3.16900315 C14.8220045,3.21869675 14.7658254,3.27588285 14.7170069,3.33931471 L11.1157759,7.9817808 C10.8351374,8.32717264 11.0968139,8.85672806 11.5382954,8.85672806 L12.9602273,8.85672806 C12.9214108,11.5664985 12.9214108,15.0054296 8.25741176,17.7547124 C8.13873153,17.8371431 8.19651007,18.0176734 8.33839094,17.9985985 C17.2603777,16.5940958 17.980267,10.505344 18.0001214,8.87489462 L19.4798318,8.87489462 C19.7778709,8.8637676 20.0107697,8.60852734 19.9996155,8.30514568 C19.9953706,8.18776302 19.954329,8.07484477 19.8824969,7.98291621 L19.8811584,7.9817808 Z M8.47692556,9.1426244 L7.05722451,9.1426244 C7.09715639,6.43285391 7.09715639,2.99392287 11.76004,0.245775511 C11.8798357,0.163344716 11.8209417,-0.0205917708 11.6801763,0.00188935528 C2.75595864,1.40525662 2.03495396,7.51331046 2.01621498,9.12332242 L0.536727645,9.12332242 C0.0963615424,9.12332242 -0.164199556,9.65287784 0.116439024,9.99826968 L3.73774751,14.6407358 C4.07081062,15.0737813 4.68562773,15.1500809 5.11104727,14.8110473 C5.17336209,14.7613537 5.22954113,14.7041676 5.27835962,14.6407358 L8.89855268,9.99713427 C9.15799836,9.67081732 8.91639933,9.14126191 8.47714865,9.14126191 L8.47692556,9.1426244 L8.47692556,9.1426244 Z" id="形状"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>

                <div className='flex items-center justify-between mt-[20px]' onClick={() => {
                    downLoadHandle(characterInfo)
                }}
                >
                    {
                        <div className='ml-1 text-white'>
                            <span className='text-white'>{t("talk.download")}</span> {shopCount[3] > 0 && <span className='text-white'> ( {shopCount[3]} )</span>}
                        </div>
                    }
                    <img className=' w-[22px] h-[22px]' src={download} alt="" />
                </div>

                <div className='flex items-center justify-between mt-[20px]' onClick={(e) => {
                    e.stopPropagation()
                    dispath(removeShareLogList())
                    setIsShare(true)
                    setMenuList(false)
                }}>
                    <span className='text-white'>{t("talk.share")}</span>
                    <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                        <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="人物聊天三个按钮展开" transform="translate(-337.000000, -140.000000)" fillRule="nonzero">
                                <g id="编组-4" transform="translate(337.000000, 140.000000)">
                                    <rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="22" height="22"></rect>
                                    <g id="编组备份-4" transform="translate(3.000000, 3.000000)" fill="#FFFFFF">
                                        <path d="M8.89787636,13.0758761 C8.87282756,13.2493384 8.93314862,13.4241451 9.06086812,13.548216 L9.06588172,13.5520887 C9.17688812,13.664329 9.33035062,13.7279419 9.49087552,13.7282561 C9.67586403,13.7282561 9.83385879,13.6411607 9.94286306,13.514342 L15.8287781,7.29438001 C15.9475705,7.17963984 16.0095188,7.02091381 15.9987757,6.85880655 C16.0096505,6.69668024 15.9476823,6.53790328 15.8287781,6.42323309 L9.90985964,0.168432906 C9.67402822,-0.0561443019 9.29570346,-0.0561443019 9.05987204,0.168432906 C8.9327792,0.292847378 8.87287999,0.467504802 8.89787636,0.640788911 L8.89787636,4.00921189 C3.98395197,4.00921189 0,7.84804649 0,12.5851208 C-0.000338104389,13.7605372 0.250942241,14.9232713 0.737995432,16 C1.43999886,12.4283169 4.97793942,9.7151985 8.88788236,9.7151985 L8.89787636,13.0758761 Z" id="路径"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>

                {/* <div className='flex items-center justify-between mt-[20px]' onClick={() => { downLoadHandle({ image: characterInfo.image, id: characterInfo.id }) }}>

                    {
                        <div className='ml-1 text-white'>
                            <span className='text-white'>{t("talk.download")}</span> {shopCount[3] > 0 && <span className='text-white'> ( {shopCount[3]} )</span>}
                        </div>
                    }
                    <img className=' w-[22px] h-[22px]' src={download} alt="" />
                </div> */}

                <div onClick={(e) => { e.stopPropagation(); setLanguageList(!languageList) }} ref={logOption} className='flex items-center justify-between mt-[20px] bg-[#444] w-full h-[40px] rounded-md p-[10px]'>
                    <span className='text-white'>{languageValue}</span>
                    {
                        languageList ? <svg className='rotate-180' width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                            <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="人物聊天三个按钮展开" transform="translate(-325.000000, -189.000000)" fillRule="nonzero">
                                    <g id="right备份-10" transform="translate(336.000000, 200.000000) rotate(-270.000000) translate(-336.000000, -200.000000) translate(325.000000, 189.000000)">
                                        <rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="22" height="22"></rect>
                                        <polygon id="路径" fill="#FFFFFF" points="13.7643067 12.0032206 8 6.13628305 9.11860304 5 16 12.0037483 9.11808437 19 8.00105896 17.8626397"></polygon>
                                    </g>
                                </g>
                            </g>
                        </svg> :
                            <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="人物聊天三个按钮展开" transform="translate(-325.000000, -189.000000)" fillRule="nonzero">
                                        <g id="right备份-10" transform="translate(336.000000, 200.000000) rotate(-270.000000) translate(-336.000000, -200.000000) translate(325.000000, 189.000000)">
                                            <rect id="矩形" fill="#000000" opacity="0" x="0" y="0" width="22" height="22"></rect>
                                            <polygon id="路径" fill="#FFFFFF" points="13.7643067 12.0032206 8 6.13628305 9.11860304 5 16 12.0037483 9.11808437 19 8.00105896 17.8626397"></polygon>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                    }

                </div>
                <div className={`${languageList ? '' : 'hidden'} language flex flex-col items-center justify-between mt-2 bg-[#444] w-full rounded-md p-[10px] max-h-[210px] overflow-auto`}>
                    {
                        languageArray.map((item: any) => {
                            return (
                                <div onClick={async (e) => {
                                    e.stopPropagation()
                                    const loading = Toast.loading({
                                        message: t("other.loading"),
                                        forbidClick: true,
                                    });
                                    try {
                                        const { code } = await putCurrentAvatarLanguage(currID, item)
                                        if (code == 0) {
                                            setLanguageValue(item)
                                            setLanguageList(false)
                                            loading.clear()
                                        }
                                    } catch (e) {
                                        loading.clear()
                                    }


                                }} className={`flex items-center text-left w-full mb-[16px]`} key={item} >
                                    <span className={`${languageValue == item ? 'text-[#00E49F]' : 'text-white'}`}>{item}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            {/* <div className='w-full h-[calc(100%_-_0x)] p-4 border-red-800 border-1'> */}
            {/* <div className={`relative say-box w-full h-full flex flex-col overflow-y-auto`} ref={sayRef}> */}
            <div className="chats-content  box-border overflow-auto" ref={mainRef}>
                {
                    Array.isArray(charList) && charList.map((item: any, index: number) => {
                        // return <div className='chats'>asdjasljdlasjdlasj</div>
                        return <Chars info={item} content={item.status != 'pending' ? item.content : isShowTry ? characterInfo.name + ` ${t("talk.typin")}` : chatMessage} key={index}></Chars>
                    })
                }

                <div className="blank h-[10px] w-full" ref={chatContainer}></div>
            </div>
            <div className='input-container h-[62px] md:px-4 box-border relative'>
                {!localStorage.getItem('token') &&
                    <div className=' w-[calc(100%_-_32px)] h-[100%] absolute z-[1000]' onClick={() => {
                        dispatch(changeLoginState(true))
                    }}> </div>
                }
                {
                    isTalkMessage && <TalkMessage text={messageText} bottom={60}></TalkMessage>
                }
                <div className={`say-input w-[calc(100%_-_0px)] h-[52px] rounded-lg bg-white/40 z-[499]  px-2 py-[6px] flex items-center justify-between relative`} >
                    <div className="audio w-[26px] h-[26px]" onTouchStart={(e) => { e.stopPropagation(), audioHandle() }}>
                        {dialog ?
                            <img className='w-full h-full' src={keys} alt="" />
                            :
                            <img className='w-full h-full' src={audioImg} alt="" />
                        }
                    </div>
                    <div className={"input w-[calc(100%_-_90px)] h-full rounded-lg overflow-hidden z-[600] relative"} >

                        <input ref={inputRef} style={{ userSelect: "text" }} value={inputValue} onFocus={() => { focusHandle() }} onBlur={(e) => { e.stopPropagation(); blurHandle() }} onKeyDown={(e) => { keyDownHandle(e) }} onInput={(e: any) => setInput(e.target.value)} enterKeyHint="done" className="input-content w-full h-full outline-none bg-white/60 backdrop-blur-[20px] text-[#333333] p-[11px] pr-[28px]" type="text" placeholder={t("talk.sendm")} />
                        <img onClick={() => { actionHandle() }} className='w-[18px] absolute top-[50%] -translate-y-[50%] right-2' src={actionbtn} alt="" />
                    </div >
                    <div className="face w-[26px] h-[26px]" onClick={(e) => { e.stopPropagation(), emojiHandle(e) }}>

                        {emoji ?
                            <img className='w-full h-full' src={keys} alt="" />
                            :
                            <img className='w-full h-full' src={faceImg} alt="" />
                        }
                    </div>
                    <div className={sendIsShow ? "face w-[26px] h-[26px]" : 'hide'} onClick={(e) => { e.stopPropagation(); sendHandle() }}>
                        <img className='w-full h-full' src={sendImg} alt="" />
                    </div>

                    {
                        emoji &&
                        <div className={`emoji w-[70%] h-48 rounded-lg overflow-auto absolute z-[888px] bottom-14 right-1 px-2 py-[6px] flex items-start justify-between bg-white`}>
                            <Emoji sendMessageEmoji={sendMessageEmoji}></Emoji>
                        </div>
                    }
                </div >

                {/* </div> */}
                {/* </div> */}

                <PublicDialogClose closeOnClickOverlay={false} dialog={dialog} setDialog={closeAudioDialog} content={
                    <AudioRecorder ref={audioRef} sendAudio={sendAudioHandle} ></AudioRecorder>
                }></PublicDialogClose>

                {/* 领取卡牌 */}
                <DrawCardsDialog property={property.property} is_my={property.is_my} power={property.power} setCardUrl={setCardUrl} dialog={drawCard} setDialog={setDrawCard} description={description} cardLevel={cardLevel} imgUrl={cardUrl} isNft={cardLevel == 9 ? true : false} nft_link={characterInfo?.nft}></DrawCardsDialog>

                <GetCoinAnimationDialog dialog={claimPointsDialog} getCoinAnimation={getCoinAnimation} point={points} setDialog={setClaimPointsDialog}></GetCoinAnimationDialog>

                <PublicDialog width={290} dialog={coinCap} setDialog={setCoinCap} content={coinCapDialog()}></PublicDialog>
            </div >
            <div className={`${actionBtn ? "" : "hidden"} talkActionBtn`}>
                {
                    isActionBtnLoading &&
                    <>
                        <div className="relative z-[2] loading-item p-1 text-center text-white overflow-hidden rounded-lg flex items-center justify-center bg-[#000]/[.4]">
                            <div className='w-full text-white border border-[#555] rounded-lg flex items-center justify-center z-[4px] overflow-hidden bg-[#000]/[.3]'>
                                <span className='mr-2 text-transparent bg-clip-text bg-gradient-to-r text-[14px] leading-[18px] from-[#00E49F] to-[#54ADFF]'>{t("talk.gener")}</span>
                                <Loading type="ball" color='#fff' />
                            </div>
                            {/* <div className='absolute top-0 left-0 w-full h-full p-1 rounded-lg -z-[1] bg-gradient-to-l from-[#00E49F] to-[#54ADFF]'>

                            </div> */}
                        </div>
                    </>

                }
                {
                    !isActionBtnLoading && actionListStore?.length > 0 && <div className="content-text">
                        {
                            actionListStore?.map((item: string, index: number) => {
                                return <div key={item} className={`${activeIndex == index ? '' : 'truncate'}  w-full relative py-2 px-8 my-1 rounded-xl text-white bg-[#000]/[.4]`} onClick={(e) => { e.stopPropagation(), sendHandle(item) }}>
                                    <img className='h-full  absolute right-0 bottom-0' src={border} alt="" />
                                    <img className='h-full rotate-180 absolute left-0 bottom-0' src={border} alt="" />
                                    <div className="icon absolute top-[50%] -translate-y-[50%] left-1 text-xs text-white" onClick={(e) => { e.stopPropagation(); setInput(""); setInput(item) }}>
                                        <img className='h-4 w-4' src={edit} alt="" />
                                    </div>

                                    {item}
                                    <div className="icon absolute top-[50%] -translate-y-[50%] right-1 text-xs text-white" onClick={(e) => { e.stopPropagation(); if (index == activeIndex) { setActiveIndex(-1) } else { setActiveIndex(index) } }}> {
                                        activeIndex == index ?
                                            <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="动作按钮完成" transform="translate(-333.000000, -640.000000)" fillRule="nonzero">
                                                        <g id="right备份-9" transform="translate(341.000000, 648.000000) scale(1, -1) rotate(-270.000000) translate(-341.000000, -648.000000) translate(333.000000, 640.000000)">
                                                            <rect id="矩形" fill="#000000" opacity="0" x="1.13686838e-13" y="3.19632815e-14" width="16" height="16"></rect>
                                                            <polygon id="路径" fill="#FFFFFF" points="9.32323003 8.00230046 5 3.81163075 5.83895228 3 11 8.00267733 5.83856328 13 5.00079422 12.1875998"></polygon>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg> : <svg className='rotate-180' width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="动作按钮完成" transform="translate(-333.000000, -640.000000)" fillRule="nonzero">
                                                        <g id="right备份-9" transform="translate(341.000000, 648.000000) scale(1, -1) rotate(-270.000000) translate(-341.000000, -648.000000) translate(333.000000, 640.000000)">
                                                            <rect id="矩形" fill="#000000" opacity="0" x="1.13686838e-13" y="3.19632815e-14" width="16" height="16"></rect>
                                                            <polygon id="路径" fill="#FFFFFF" points="9.32323003 8.00230046 5 3.81163075 5.83895228 3 11 8.00267733 5.83856328 13 5.00079422 12.1875998"></polygon>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>}</div>
                                </div>
                            })
                        }
                    </div>
                }
                {
                    !isActionBtnLoading && actionListStore.length > 0 && <div className='relative flex items-center justify-center mt-2'>
                        <span className='text-white absolute top-[50%] left-0 -translate-y-[50%]'>{actionCount.current}/3</span>
                        <ButtonComp title={t("card.regenerate")} height={30} width={110} callBack={() => { regenerateHandle() }}>
                            <svg className={`mr-[6px] ${isActionBtnLoading ? 'animate-spin' : ''}`} width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <defs>
                                    <linearGradient x1="-2.72351586e-14%" y1="-1.94289029e-13%" x2="100%" y2="100%" id="linearGradient-1">
                                        <stop stopColor={'#fff'} offset="0%"></stop>
                                        <stop stopColor={'#fff'} offset="100%"></stop>
                                    </linearGradient>
                                </defs>
                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="10-cards-sale" transform="translate(-279.000000, -60.000000)" fill="url(#linearGradient-1)" fillRule="nonzero">
                                        <g id="编组" transform="translate(279.000000, 60.000000)">
                                            <path d="M11.7148409,2.30618042 C11.4911427,2.21958428 11.2443829,2.34576723 11.1659732,2.58576224 L10.8338852,3.58532915 C10.444143,2.64266829 9.8283965,1.8138195 9.04429979,1.19280144 C6.55133349,-0.786538945 2.99983662,-0.247168689 1.13184152,2.40019909 C0.227824132,3.68182199 -0.154999551,5.26034596 0.0571677919,6.84381828 C0.269335135,8.43471312 1.05573801,9.84251898 2.26647558,10.8049732 C3.28118897,11.6090803 4.46886487,12 5.6473161,12 C7.3700227,12 9.06966762,11.1711512 10.1789338,9.60004977 C10.6701474,8.90480646 11.0045416,8.12791535 11.1775041,7.28669569 C11.2282397,7.03680397 11.0806451,6.7918606 10.8500284,6.73742873 C10.6194117,6.68299687 10.388795,6.83886993 10.3380593,7.08876165 C10.1927708,7.79885002 9.90911231,8.4569807 9.4940023,9.04336029 C7.90966572,11.2874375 4.89550572,11.7451599 2.7784446,10.0627206 C1.75220038,9.24871686 1.08802434,8.05863844 0.908143328,6.71268697 C0.728262313,5.37415803 1.05112567,4.04057745 1.81677305,2.95688857 C3.39880347,0.712811404 6.41065731,0.252614756 8.53002459,1.93505409 C9.29797813,2.54370126 9.87221366,3.38739511 10.1835462,4.33995266 L8.70529326,3.72140878 C8.48390124,3.62986429 8.23483523,3.74615054 8.14720089,3.98367139 C8.05956655,4.22119224 8.17026256,4.4884032 8.39165457,4.58242186 L10.568676,5.49539262 C10.6194117,5.5176602 10.6724535,5.5275569 10.7254954,5.5275569 C10.7324139,5.5275569 10.7393324,5.52508272 10.7462509,5.52508272 C10.762394,5.5275569 10.7785372,5.53497942 10.7946804,5.53497942 C10.9722552,5.53497942 11.1382992,5.416219 11.2005657,5.22818165 L11.9754378,2.90245669 C12.0538474,2.65751334 11.9385391,2.39277656 11.7148409,2.30618042 Z" id="路径"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </ButtonComp>
                    </div>
                }
            </div>
            {
                coinsShow && !actionBtn &&
                <div className='md:px-4'>
                    <CoinProgressBar userInfo={userInfo} coinsShow={coinsShow}></CoinProgressBar>
                </div>

            }
            <PublicDialog width={'290'} dialog={is_report} setDialog={setReport} content={reportText()}></PublicDialog>

            <PublicDialog width={'320'} pb={32} dialog={saveChatLogPayDialog} setDialog={setSaveChatLogPayDialog} content={saveChatLogPay()}></PublicDialog>

            <PromptDialog
                title={t("other.attention")}
                dialog={coinAction}
                setDialog={setCoinAction}
                text_mt={30}
                text={t("talk.regen")}
                callback={() => { setCoinAction(false), getActionListHandler() }}
            ></PromptDialog>
            <PromptDialog is={false} isClose={true} title={text} dialog={pointsDialog} setDialog={setPointsDialog} callback={async () => {
                if (isResetChat) {
                    setIsResetChat(false)
                    try {
                        const res = await removeChatLogs(characterInfo.id)
                        if (res.code === "0") {
                            dispath(removeChatList(characterInfo.id))
                            setPointsDialog(false)
                            setMessageText(t("talk.forgo"))
                            setIsTalkMessage(true)
                            setTimeout(() => {
                                setIsTalkMessage(false)
                            }, 1200)
                        }

                    } catch (e) {

                    }

                } else {
                    setPointsDialog(false)
                }
            }} text={promptText}></PromptDialog>
            <PromptDialog isClose={true} title={t("other.neterror")} dialog={networkError} setDialog={setNetWorkError} callback={() => {
                resetApiHandle()

            }} text={t("talk.retry")}></PromptDialog>

            {
                isShare && <ShareLog id={currID} charList={charList} callback={() => { setIsShare(false) }} ></ShareLog>
            }


            {/* 亲密度 */}
            {
                <Popup
                    style={{ height: '450px', padding: "20px 25px", background: `linear-gradient( 180deg, #333 0%, #333333 100%)`, borderRadius: "20px 20px 0px 0px" }}
                    position="bottom"
                    visible={showIntimacyPopup}
                    onClose={() => setShowIntimacyPopup(false)}>
                    <div className='text-white w-full h-full text-center relative'>
                        <CloseComp position='absolute' right={2} top={0} callBack={() => { setShowIntimacyPopup(false) }}></CloseComp>
                        <div className=''>
                            <span className='text-transparent bg-clip-text bg-gradient-to-r from-[#00E49F] to-[#54ADFF] text-[20px] font-bold'>{t("talk.intim1")}</span>

                            <div className="level">
                                <span className='text-white text-[20px]'>{t("talk.lv")}</span>
                                <span className='mx-2 text-transparent bg-clip-text bg-gradient-to-r from-[#00E49F] to-[#54ADFF] text-[30px] font-bold'>{intimacyList?.level}</span>
                                <span className='text-white text-[20px]'>({intimacyList?.intimacies}/{intimacyList?.level == 10 ? '10000' : intimacyList?.list[intimacyList?.level - 1]?.start})</span>
                            </div>
                            <div className='h-8 flex items-center'>
                                <svg className='mr-2' width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                    <defs>
                                        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
                                            <stop stopColor="#00E49F" offset="0%"></stop>
                                            <stop stopColor="#54ADFF" offset="100%"></stop>
                                        </linearGradient>
                                    </defs>
                                    <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="亲密度弹窗" transform="translate(-23.000000, -502.000000)" fill="url(#linearGradient-1)" fillRule="nonzero">
                                            <g id="编组备份-2" transform="translate(23.000000, 502.000000)">
                                                <path d="M19.9902134,6.86327482 C19.9746581,7.16325712 19.9368811,7.45573988 19.8879932,7.74572278 C19.0342556,6.77187993 17.8705502,6.22124084 16.6547245,6.21581302 C15.3041874,6.24217604 14.0389173,6.96353613 13.2214597,8.17319756 C12.6103608,7.8232182 12.1081486,7.59323178 11.42594,7.59323178 C11.1059464,7.59323178 10.5348467,7.51073665 10.2192975,7.59323178 C7.84156721,8.21319521 6.55492624,11.0380286 7.00158399,14.0278522 C7.27713404,15.8777431 8.2837806,17.3201581 9.6459756,18.3400979 C7.60379417,19.4150345 6.1993778,20 6.1993778,20 C6.1993778,20 5.63050027,17.4951477 4.60385411,15.6502566 C2.81722315,12.4454456 -0.240493533,11.2905137 0.0150569031,6.37330373 C0.206164211,2.67102209 2.90166591,0.688639022 5.25939658,0.666140335 C6.84380937,0.648641376 8.68821695,1.58358623 9.24376141,3.18599172 C10.3948495,1.25610556 12.388143,-0.216307601 14.999202,0.0261780918 C18.0724739,0.313661139 20.1613211,3.13849451 19.9902134,6.86077497 L19.9902134,6.86327482 Z M8.20822655,14.0278522 C7.88601078,11.8754792 8.83043635,9.62311205 10.5770681,9.16813887 C10.8059524,9.11064227 11.0326146,9.08064404 11.2570545,9.08064404 C12.1659252,9.08064404 13.0236859,9.54811646 13.6392291,10.3255706 C13.9792224,9.06564491 14.8392052,8.05820435 15.9858489,7.75822205 C16.8634724,7.54147304 17.7816991,7.74386965 18.521715,8.31718063 C19.261731,8.89049161 19.7572593,9.78337049 19.8902154,10.7830436 C20.2746521,13.8053654 18.685795,14.5828195 17.4591528,16.7826898 C16.3547305,18.7675727 17.0591608,19.5400271 17.0591608,19.5400271 C17.0591608,19.5400271 8.8948795,18.6350805 8.20822655,14.0278522 Z" id="形状"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                <div className=' bg-[rgba(166,166,166,0.48)] my-[10px] rounded-[8px] flex-1 h-[10px]'>
                                    <div className='h-[10px] w-[0%] rounded-[8px]' style={{ background: 'linear-gradient( 135deg, #00E49F 0%, #54ADFF 100%)', width: prossesLin + '%', }}>

                                    </div>
                                </div>

                            </div>
                            <div className='text-white flex items-center justify-around my-4'>
                                <img className='h-[3px]' src={lineImg} alt="" />

                                <span className='text-sm'>{t("talk.intim")}</span>
                                <img className='h-[3px] rotate-[180deg]' src={lineImg} alt="" />
                            </div>

                            <div className='h-[240px] overflow-y-auto overflow-x-hidden'>
                                {
                                    intimacyList?.list?.length && intimacyList?.list?.map((item: any) => {
                                        return (
                                            <div className={`${intimacyList?.level < item.level ? 'bg-[#444]' : 'border-t border-b border-[#00E49F]'} w-full h-11 flex items-center relative  my-4 rounded-full py-1 pl-[50px] pr-[30px]`}>
                                                <div className={`${intimacyList?.level < item.level ? 'bg-[#a6a6a6]' : 'bg-gradient-to-r from-[#00E49F] to-[#54ADFF]'} w-[44px] h-[44px] flex justify-center items-center text-white rounded-full absolute -top-[1px] -left-[0px]`}>
                                                    {t("talk.lv")} {item.level}
                                                </div>
                                                <div className='absolute right-[12px]'>

                                                    {
                                                        intimacyList?.level < item.level ? <i className='iconfont icon'>&#xe60f;</i> : <svg width="20px" height="20px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                            <defs>
                                                                <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
                                                                    <stop stop-color="#00E49F" offset="0%"></stop>
                                                                    <stop stop-color="#54ADFF" offset="100%"></stop>
                                                                </linearGradient>
                                                                <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-2">
                                                                    <stop stop-color="#00E49F" offset="0%"></stop>
                                                                    <stop stop-color="#54ADFF" offset="100%"></stop>
                                                                </linearGradient>
                                                            </defs>
                                                            <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                                <g id="亲密度弹窗" transform="translate(-317.000000, -587.000000)" fillRule="nonzero">
                                                                    <g id="编组" transform="translate(317.000000, 587.000000)">
                                                                        <path d="M12.5713767,9.30769231 L12.5713767,5.86454274 C12.5713767,3.85357342 14.1432029,2.22344301 16.0822467,2.22344301 C18.0210312,2.22344301 19.5928575,3.85357342 19.5928575,5.86454274 C19.5928575,6.55387194 20.1317545,7.11275842 20.7964287,7.11275842 C21.461103,7.11275842 22,6.55387194 22,5.86454274 C21.8698141,2.58706887 19.269986,0 16.1071429,0 C12.9442997,0 10.344731,2.58733782 10.2142857,5.86454274 L10.2142857,9.30769231" id="路径" fill="url(#linearGradient-1)"></path>
                                                                        <path d="M14.5726091,22 L2.73300193,22 C1.22747856,22 0.00561191362,20.6395125 0,18.9572167 L0,11.5154382 C0,9.8331425 1.21753017,8.46752426 2.72305354,8.46153846 L14.5626607,8.46153846 C16.0681841,8.46752426 17.2857143,9.8331425 17.2857143,11.5154382 L17.2857143,18.9569317 C17.2806125,20.6306763 16.0704799,21.9877434 14.5726091,22 Z M10.5473366,13.4779265 C10.5501425,12.4614802 9.9096191,11.5847025 9.01783501,11.3848907 C8.12605092,11.1850789 7.23222613,11.7178154 6.8840324,12.6564463 C6.53583867,13.5953623 6.83046413,14.6782226 7.58730721,15.2417432 L7.58730721,17.9427656 C7.59266404,18.5900875 8.06380969,19.1114224 8.64311223,19.1114224 C8.92480779,19.1173235 9.19692727,18.997158 9.39891044,18.7776687 C9.60089361,18.5581794 9.71598066,18.2575788 9.71855895,17.9427656 L9.71855895,15.2417432 C10.2419756,14.8462403 10.5531747,14.1839418 10.5473366,13.4779265 L10.5473366,13.4779265 Z" id="形状" fill="url(#linearGradient-2)"></path>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    }

                                                </div>
                                                <div className={`${intimacyList?.level < item.level ? 'text-[#a6a6a6]' : 'text-white'}  !text-[14px] leading-4 text-left  flex item-center`}>
                                                    {
                                                        item.type == 1 && <i className={`${intimacyList?.level < item.level ? 'opacity-50' : ''}  iconfont mr-2 `}>&#xe610;</i>
                                                    }

                                                    {item.type == 1 ? <span className={`${intimacyList?.level < item.level ? 'text-[#a6a6a6]' : 'text-style-level'}  !text-[14px] !leading-[18px]`}>{item.msg}</span> : item.msg}

                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>


                        </div>
                    </div>
                </Popup>
            }

            <Pay dataObj={payData} callBack={(item) => {
                if (item?.code == '0') {
                    getSaveLogs()
                }
            }}></Pay>
            <PromptDialog title={t("other.attention")} dialog={promptDialog} setDialog={setPromptDialog} callback={() => {
                navigate('/agents')
                setPromptDialog(false)
                dispatch(changeLoginState(true))
            }} text={prompt}></PromptDialog>

            {/* {characterInfo.image && <ShareContent shareDialog={shareDialog} setShareDialog={setShareDialog} image={characterInfo.image}></ShareContent>} */}
            {characterInfo.main_image &&
                <ShareContent
                    // bonusPower={actionArr?.bonus_power}
                    // power={actionArr?.power}
                    // property={actionArr?.property}
                    // enhanceLevel={actionArr?.enhance_level}
                    mint_state={characterInfo?.mint_state}
                    is_nft={characterInfo?.mint_state == 3}
                    // level={actionArr?.is_official ? 6 : actionArr?.level + 1}
                    // shareStatus={shareStatusList?.cardDomainShare}
                    // code={'cardDomainShare'}
                    // cardId={actionArr.id}
                    // teleport={popupRef.current}
                    // shareDialog={shareDialog}
                    // setShareDialog={setShareDialog}
                    // image={actionArr.image}
                    // pageName={typeActive == 2 ? 'Sale' : 'Display'}
                    shareStatus={shareStatusList?.avatarDomainShare}
                    code={'avatarDomainShare'}
                    cardId={characterInfo.link}
                    property={characterInfo?.property}
                    pageName={'agents'}
                    teleport={talkRef.current}
                    shareDialog={shareDialog}
                    setShareDialog={setShareDialog}
                    image={characterInfo?.bg_image}
                    isHero={true}
                >
                </ShareContent>}
            {
                showPayDialog && <PayDialog teleport={talkRef.current} isNeedDialogSuccess={false} dataList={payDownLoad} title={t("card.main.purchase_image_download")} callBack={async (val) => {
                    setShowPayDialog(false)
                    if (val != 'close') {
                        const params = {
                            url: characterInfo.main_images[0],
                            file_name: characterInfo.link
                        }
                        try {
                            downloadFile(params)
                            await updateDownLoadCount(characterInfo.id)
                            getCardInoHandle()
                        } catch (e) {
                        }
                        // WebApp.downloadFile(params, async (status) => {
                        //     if (!status) {
                        //         dispatch(changeShopCount({ type: 3, count: await getShopPayCountHandle(10) }))
                        //     }
                        // })
                    }
                }} />
            }
        </div>
    )
}
export default Talk;
